import React from "react";

export default function NewDailyUpdateButton({ onClick, isOpen }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "3px solid var(--main-purple)",
        backgroundColor: isOpen ? "transparent" : "rgba(185, 151, 255, 0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.2s ease",
        marginBottom: "0.75rem",
        padding: 0,
      }}
    >
      <ion-icon
        name={isOpen ? "add-outline" : "remove-outline"}
        style={{
          "--ionicon-stroke-width": "4rem",
          fontSize: "1.6rem",
          color: "var(--main-purple)",
        }}
      ></ion-icon>
    </button>
  );
}
